import { useEffect, useState } from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) {
        return null;
    }

    const orders = Number(payload[0].value || 0);

    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "12px 16px",
                minWidth: "135px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
            }}
        >
            <div
                style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#6b7280",
                    marginBottom: "6px"
                }}
            >
                {label}
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "6px"
                }}
            >
                <span
                    style={{
                        fontSize: "24px",
                        fontWeight: 700,
                        color: "#1976d2"
                    }}
                >
                    {orders.toLocaleString()}
                </span>

                <span
                    style={{
                        fontSize: "12px",
                        color: "#9ca3af"
                    }}
                >
                    orders
                </span>
            </div>
        </div>
    );
};

// CUSTOM CHART
const ChartMonthlyOrders = () => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [monthlyOrders, setMonthlyOrders] = useState([]);

    // GET MONTHLY SALES PER YEAR
    const getMonthlySales = async (year = new Date().getFullYear(), signal) => {
        try {
            const response = await fetch(`${apiUrl}dashboard/monthly_sales.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                signal,
                body: JSON.stringify({
                    year
                })
            }
            );

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const result = await response.json();

            if (result.status !== "success") {
                throw new Error(result.message || "Failed to fetch monthly sales");
            }

            setMonthlyOrders(result.data || []);

        } catch (error) {

            if (error.name === "AbortError") {
                throw error;
            }

            console.error("getMonthlySales error:", error);
            throw error;
        }
    };

    useEffect(() => {
        getMonthlySales();
    }, []);

    return (
        <div
            style={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "8px",
                background: "#fff",
                padding: "20px 20px 10px 20px",
                boxSizing: "border-box",
                marginTop: 20,
            }}
        >
            {/* Title */}
            <h2
                style={{
                    margin: "0 0 20px 0",
                    fontSize: "24px",
                    fontWeight: 600,
                    color: "#111"
                }}
            >
                Monthly Orders
            </h2>

            <ResponsiveContainer
                width="100%"
                height={390}
            >
                <BarChart
                    data={monthlyOrders}
                    margin={{
                        top: 5,
                        right: 5,
                        left: 45,
                        bottom: 25
                    }}
                    barCategoryGap="15%"
                >
                    {/* Grid */}
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={true}
                        horizontal={true}
                        stroke="#cfcfcf"
                    />

                    {/* X Axis */}
                    <XAxis
                        dataKey="month"
                        axisLine={{
                            stroke: "#777"
                        }}
                        tickLine={{
                            stroke: "#777"
                        }}
                        tick={{
                            fontSize: 14,
                            fill: "#555"
                        }}
                        dy={8}
                    />

                    {/* Y Axis */}
                    <YAxis
                        domain={[0, 3000]}
                        ticks={[0, 500, 1000, 1500, 2000, 2500, 3000]}
                        allowDecimals={false}
                        axisLine={{
                            stroke: "#777"
                        }}
                        tickLine={false}
                        tick={{
                            fontSize: 14,
                            fill: "#555"
                        }}
                        tickFormatter={(value) =>
                            value.toLocaleString()
                        }
                    />

                    {/* Tooltip */}
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={{
                            fill: "#d0d0d0",
                            opacity: 1
                        }}
                    />

                    {/* Bars */}
                    <Bar
                        dataKey="orders"
                        name="Orders"
                        fill="#1976d2"
                        barSize={105}
                        radius={[8, 8, 0, 0]}
                        isAnimationActive={true}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ChartMonthlyOrders;